<p>{{ 'FILTERS.' + translationKey + '.INTRO' | translate }}</p>
<filter-component name="{{ 'FILTERS.' + translationKey + '.TITLE' | translate }}">
	<ng-container filter-content>
		
		<input 
			[id]="id" 
			autocomplete="no-auto" 
			[ngClass]="{'_not-valid': !valueIsValid}" 
			(input)="onValueChange($any($event.target).value)" 
			AutoSizeInput placeholder="{{ 'FILTERS.' + translationKey  + '.PLACEHOLDER' | translate }}" 
			(keyup.enter)="filterData($any($event.target).value)" 
			[type]="type"
		/>
		
	</ng-container>
</filter-component>

